export const specialKeyPressed = ev => ev.metaKey || ev.altKey || ev.ctrlKey || ev.shiftKey
